/*
	AUTHOR: Osvaldas Valutis, www.osvaldas.info

	https://www.jqueryscript.net/other/Clean-Audio-Player-jQuery.html
*/

import $ from "jquery";

var isTouch = "ontouchstart" in window,
  eStart = isTouch ? "touchstart" : "mousedown",
  eMove = isTouch ? "touchmove" : "mousemove",
  eCancel = isTouch ? "touchcancel" : "mouseup",
  secondsToTime = function (secs) {
    var hours = Math.floor(secs / 3600),
      minutes = Math.floor((secs % 3600) / 60),
      seconds = Math.floor((secs % 3600) % 60);
    const hours_str =
      hours === 0
        ? ""
        : (hours > 0 && hours.toString().length < 2 ? "0" + hours : hours) +
          ":";
    const minutes_str = minutes.toString().length < 2 ? "0" + minutes : minutes;
    const seconds_str = seconds.toString().length < 2 ? "0" + seconds : seconds;
    return hours_str + minutes_str + ":" + seconds_str;
  },
  canPlayType = function (file) {
    if (file.slice(0, 5) === "blob:") return true; // for audio that create by blob;
    var videoElement = document.createElement("video");
    return !!(
      videoElement.canPlayType &&
      videoElement
        .canPlayType("video/" + file.split(".").pop().toLowerCase() + ";")
        .replace(/no/, "")
    );
  },
  params = {
    classPrefix: "audioplayer",
    strPlay: "",
    strPause: "",
    strVolume: "",
  },
  cssClass = {},
  cssClassSub = {
    playPause: "playpause",
    playing: "playing",
    time: "time",
    timeCurrent: "time-current",
    timeDuration: "time-duration",
    bar: "bar",
    barLoaded: "bar-loaded",
    barPlayed: "bar-played",
    volume: "volume",
    volumeButton: "volume-button",
    volumeAdjust: "volume-adjust",
    noVolume: "novolume",
    mute: "mute",
    mini: "mini",
  };

export const changeVideo = (video_id, durationSeconds, setCurrentTime) => {
  for (var subName in cssClassSub)
    cssClass[subName] = params.classPrefix + "-" + cssClassSub[subName];

  var thePlayer = $(".audioplayer"),
    $this = $("#" + video_id),
    videoFile = $this.attr("src"),
    isAutoPlay = $this.get(0).getAttribute("autoplay"),
    isLoop = $this.get(0).getAttribute("loop"),
    isSupport = true;

  isAutoPlay = isAutoPlay === "" || isAutoPlay === "autoplay";
  isLoop = isLoop === "" || isLoop === "loop";
  if (typeof videoFile === "undefined") {
    $this.find("source").each(function () {
      videoFile = $(this).attr("src");
      if (typeof videoFile !== "undefined" && canPlayType(videoFile)) {
        isSupport = true;
        return false;
      }
    });
  } else if (canPlayType(videoFile)) isSupport = true;

  var theVideo = isSupport
    ? thePlayer.find("video")
    : $(
        '<embed src="' +
          videoFile +
          '" width="0" height="0" volume="100" autostart="' +
          isAutoPlay.toString() +
          '" loop="' +
          isLoop.toString() +
          '" />'
      );
  theVideo = theVideo.get(0);

  if (isSupport) {
    var theBar = thePlayer.find("." + cssClass.bar),
      barPlayed = thePlayer.find("." + cssClass.barPlayed),
      barLoaded = thePlayer.find("." + cssClass.barLoaded),
      timeCurrent = thePlayer.find("." + cssClass.timeCurrent),
      timeDuration = thePlayer.find("." + cssClass.timeDuration),
      volumeButton = thePlayer.find("." + cssClass.volumeButton),
      volumeAdjuster = thePlayer.find("." + cssClass.volumeAdjust + " > div"),
      volumeDefault = 0,
      adjustCurrentTime = function (e) {
        const theRealEvent = isTouch ? e.originalEvent.touches[0] : e;
        theVideo.currentTime = Math.round(
          (durationSeconds * (theRealEvent.pageX - theBar.offset().left)) /
            theBar.width()
        );
      },
      adjustVolume = function (e) {
        const theRealEvent = isTouch ? e.originalEvent.touches[0] : e;
        theVideo.volume = Math.abs(
          (theRealEvent.pageX - volumeAdjuster.offset().left) /
            volumeAdjuster.width()
        );
      };
    barPlayed.width(0);
    timeDuration.text(secondsToTime(durationSeconds));
    timeCurrent.text(secondsToTime(0));

    var volumeTestDefault = theVideo.volume,
      volumeTestValue = (theVideo.volume = 0.111);
    if (Math.round(theVideo.volume * 1000) / 1000 === volumeTestValue)
      theVideo.volume = volumeTestDefault;
    else thePlayer.addClass(cssClass.noVolume);

    // ---------------------------    add eventHandler and those functions   ----------------------------- --
    var updateLoadBar = setInterval(function () {
      if (theVideo.buffered.length > 0) {
        barLoaded.width(
          (theVideo.buffered.end(0) / durationSeconds) * 100 + "%"
        );
        if (theVideo.buffered.end(0) >= durationSeconds) {
          barLoaded.width("100%");
          clearInterval(updateLoadBar);
        }
      }
    }, 100);

    // -- -------  declare eventHandler's functions -------
    var loadedDataFunc = function () {
      volumeAdjuster.find("div").width(theVideo.volume * 100 + "%");
      volumeDefault = theVideo.volume;
    };

    var timeUpdateFunc = function () {
      timeCurrent.text(secondsToTime(theVideo.currentTime));
      barPlayed.width((theVideo.currentTime / durationSeconds) * 100 + "%");
      if (theVideo.currentTime / durationSeconds > 1) barPlayed.width("100%");
      setCurrentTime(theVideo.currentTime);
    };

    var volumeChangeFunc = function () {
      volumeAdjuster.find("div").width(theVideo.volume * 100 + "%");
      if (theVideo.volume > 0 && thePlayer.hasClass(cssClass.mute))
        thePlayer.removeClass(cssClass.mute);
      if (theVideo.volume <= 0 && !thePlayer.hasClass(cssClass.mute))
        thePlayer.addClass(cssClass.mute);
    };

    var endedFunc = function () {
      thePlayer.removeClass(cssClass.playing);
    };

    var barOnEstartFunc = function (e) {
      adjustCurrentTime(e);
      theBar.on(eMove, (e) => adjustCurrentTime(e));
    };

    var barOnEcancelFunc = function () {
      theBar.unbind(eMove);
    };

    var volumeButtonOnClickFunc = function () {
      if (thePlayer.hasClass(cssClass.mute)) {
        thePlayer.removeClass(cssClass.mute);
        theVideo.volume = volumeDefault;
      } else {
        thePlayer.addClass(cssClass.mute);
        volumeDefault = theVideo.volume;
        theVideo.volume = 0;
      }
      return false;
    };

    var volumeAdjusterOnEstartFunc = function (e) {
      adjustVolume(e);
      volumeAdjuster.on(eMove, function (e) {
        adjustVolume(e);
      });
    };

    var volumeAdjusterOnEcansel = function () {
      volumeAdjuster.unbind(eMove);
    };

    //------------    add eventHandler   ---------
    theBar.on("mouseleave", barOnEcancelFunc);

    theVideo.addEventListener("loadeddata", loadedDataFunc);

    theVideo.addEventListener("timeupdate", timeUpdateFunc);

    theVideo.addEventListener("volumechange", volumeChangeFunc);

    theVideo.addEventListener("ended", endedFunc);

    theBar.on(eStart, barOnEstartFunc).on(eCancel, barOnEcancelFunc);

    volumeButton.on("click", volumeButtonOnClickFunc);

    volumeAdjuster
      .on(eStart, volumeAdjusterOnEstartFunc)
      .on(eCancel, volumeAdjusterOnEcansel);
  } else thePlayer.addClass(cssClass.mini);

  //  <!-- -------------------------------------    other actions   ----------------------------------  -->

  if (isAutoPlay) thePlayer.addClass(cssClass.playing);

  var playerIconOnClickFunc = function () {
    if (thePlayer.hasClass(cssClass.playing)) {
      $(this).attr("title", params.strPlay).find("span").html(params.strPlay);
      thePlayer.removeClass(cssClass.playing);
      isSupport ? theVideo.pause() : theVideo.Stop();
    } else {
      $(this).attr("title", params.strPause).find("span").html(params.strPause);
      thePlayer.addClass(cssClass.playing);
      isSupport ? theVideo.play() : theVideo.Play();
    }

    return false;
  };
  thePlayer.find("." + cssClass.playPause).on("click", playerIconOnClickFunc);

  // return function for before unmount parent component
  return () => {
    theVideo.removeEventListener("loadeddata", loadedDataFunc);
    theVideo.removeEventListener("timeupdate", timeUpdateFunc);
    theVideo.removeEventListener("volumechange", volumeChangeFunc);
    theVideo.removeEventListener("ended", endedFunc);
    theBar?.off(eStart, barOnEstartFunc);
    theBar?.off(eCancel, barOnEcancelFunc);
    theBar?.off(eMove, (e) => adjustCurrentTime(e));
    theBar?.off("mouseleave", barOnEcancelFunc);
    volumeButton?.off("click", volumeButtonOnClickFunc);
    volumeAdjuster?.off(eStart, volumeAdjusterOnEstartFunc);
    volumeAdjuster?.off(eCancel, volumeAdjusterOnEcansel);
    thePlayer
      .find("." + cssClass.playPause)
      ?.off("click", playerIconOnClickFunc);
  };
};
